module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"addFtpConnection_Header":"Nuovo event","editFtpConnectionDialog_Header":"Modifica event","formAddEditEvent":{"Name":"Nome Evento","EventDate":"Data evento","Location":"Location"}}}')
  delete Component.options._Ctor
}
